var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15215",
    "data-name": "Grupo 15215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_95",
    "data-name": "Elipse 95",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "call_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M133.724-825.426a12.155,12.155,0,0,1-5-1.1,14.957,14.957,0,0,1-4.494-3.127,14.957,14.957,0,0,1-3.127-4.494,12.154,12.154,0,0,1-1.1-5,.824.824,0,0,1,.243-.607.824.824,0,0,1,.607-.243h3.279a.752.752,0,0,1,.506.192.739.739,0,0,1,.263.455l.526,2.834a1.428,1.428,0,0,1-.02.547.852.852,0,0,1-.223.385l-1.963,1.984a9.791,9.791,0,0,0,.961,1.447,14.231,14.231,0,0,0,1.225,1.346,14.24,14.24,0,0,0,1.316,1.164,12.8,12.8,0,0,0,1.457.982l1.9-1.9a1.135,1.135,0,0,1,.476-.273,1.3,1.3,0,0,1,.577-.051l2.793.567a.937.937,0,0,1,.466.294.713.713,0,0,1,.182.476v3.279a.824.824,0,0,1-.243.607A.824.824,0,0,1,133.724-825.426Z",
    transform: "translate(-113.844 846.774)",
    fill: "#009bde"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.985ad430dec9386c3b5ac91bfc611e29.svg";
export { ForwardRef as ReactComponent };